import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  account_id: null,
};

const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    getCustomerData: (state, action) => ({
      ...state,
      account_id: action.payload,
    }),
    removeCustomerData: state => ({
      ...state,
      account_id: null
    })
  },
});

export const { getCustomerData, removeCustomerData } = customerSlice.actions;
export default customerSlice.reducer;
